/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceObjectPatchV1Dto = {
  /**
   * ID of the area associated with the service object
   */
  areaId?: string;
  /**
   * Comments related to the service object
   */
  comments?: string;
  /**
   * Construction year of the service object
   */
  constructionYear?: number;
  /**
   * Inventory number of the service object
   */
  inventoryNumber?: string;
  /**
   * Manufacturer of the service object
   */
  manufacturer?: string;
  /**
   * Model of the service object
   */
  model?: string;
  /**
   * Name of the service object
   */
  name?: string;
  /**
   * ID of the object type associated with the service object
   */
  objectTypeId?: string;
  /**
   * Responsibility of the service object
   */
  responsibleRole?: ServiceObjectPatchV1Dto.responsibleRole;
  /**
   * Serial number of the service object
   */
  serialNumber?: string;
  /**
   * The current version of the entity
   */
  version: number;
};
export namespace ServiceObjectPatchV1Dto {
  /**
   * Responsibility of the service object
   */
  export enum responsibleRole {
    CUSTOMER = 'Customer',
    LANDLORD = 'Landlord',
    MAINTENANCE = 'Maintenance',
    PARTNER = 'Partner',
  }
}
